import React from 'react';
import PropTypes from 'prop-types';
var InstrumentTableItem = function InstrumentTableItem(props) {
  var value = props.value,
    label = props.label,
    classModifiers = props.classModifiers,
    baseClasses = props.baseClasses;
  return React.createElement('div', {
    className: baseClasses('row', classModifiers)
  }, React.createElement('span', {
    className: baseClasses('value', classModifiers)
  }, value), React.createElement('span', {
    className: baseClasses('title')
  }, label));
};
InstrumentTableItem.propTypes = {
  value: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  baseClasses: PropTypes.func.isRequired,
  classModifiers: PropTypes.arrayOf(PropTypes.string)
};
InstrumentTableItem.defaultProps = {
  classModifiers: []
};
export default InstrumentTableItem;